// extracted by mini-css-extract-plugin
export var bodyRow = "_gq-d";
export var cardColumns = "_gq-e";
export var ellipsesOverflow = "_gq-2";
export var flatBottomCorners = "_gq-3";
export var flatTopCorners = "_gq-4";
export var headerActionsDropdown = "_gq-f";
export var headerBottomRow = "_gq-c";
export var headerTopRow = "_gq-b";
export var orderDetailsWrapper = "_gq-0";
export var orderInfoContainer = "_gq-1";
export var productDetails = "_gq-9";
export var productImage = "_gq-5";
export var responsiveTable = "_gq-8";
export var shipmentContainer = "_gq-a";
export var tableBottomLeft = "_gq-6";
export var tableBottomRight = "_gq-7";